/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

// TODO: maybe we should move this to `@cp/shared-universal` so that we can move the mock data generator script
// to `@cp/shared-universal` too, so it doesn't become a "cyclic" dependency.
import { UpdateUserTitleRequest } from '@cp/ic-sdk'
import { LabelValue } from '../../types/additional-ui-types'

export const UserTitle = UpdateUserTitleRequest.shape.title.enum
export type UserTitle = keyof typeof UserTitle

export const EXCLUDED_USER_TITLES: UserTitle[] = [
  UserTitle.DELIVERY_MANAGER,
  UserTitle.EXECUTIVE_SPONSOR,
  UserTitle.ACCOUNT_MANAGER,
  UserTitle.SOLUTION_ARCHITECT
]

const USER_TITLE_TO_STRING: Record<UserTitle, string> = Object.values(UserTitle).reduce(
  (acc, title) => {
    acc[title] = toNormalCase(title)
    return acc
  },
  {} as Record<UserTitle, string>
)
export class UserTitleHelpers {
  static getUserTitle = getUserTitle

  static getUserTitleLabelValues = (options?: { excludeHubSpotRoles: boolean }) => {
    if (options?.excludeHubSpotRoles) {
      return USER_TITLES_LABEL_VALUES.filter(labelValue => !EXCLUDED_USER_TITLES.includes(labelValue.value as UserTitle))
    }
    return USER_TITLES_LABEL_VALUES.filter(labelValue => labelValue.value !== UserTitle.UNKNOWN)
  }

  static getUserTitleLabelValue = (key: string) => {
    return {
      label: renderUserTitle(key),
      value: key
    }
  }

  static getPrimaryContactTitleLabelValues = () => {
    return PRIMARY_CONTACT_TITLE_LABEL_VALUES
  }
}

function renderUserTitle(userType: string) {
  return USER_TITLE_TO_STRING[userType as UserTitle] || 'Unidentified user title'
}

const USER_TITLES_LABEL_VALUES: LabelValue[] = Object.keys(USER_TITLE_TO_STRING).map(key => ({
  label: renderUserTitle(key),
  value: key
}))

const PRIMARY_CONTACT_TITLE_LABEL_VALUES: LabelValue[] = UserTitleHelpers.getUserTitleLabelValues({ excludeHubSpotRoles: true })

// Helper functions.
function getUserTitle(userType: string[]): string
function getUserTitle(userType: string[] | null | undefined): string | undefined
function getUserTitle(userType: string[] | null | undefined) {
  if (userType === undefined || userType === null) return undefined

  return userType.map(type => renderUserTitle(type)).join(',')
}

// helper
function toNormalCase(title: UserTitle) {
  if (title === UserTitle.LIVEOPS) {
    return 'LiveOps'
  }

  return title
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' ')
}
